<template>
  <b-modal
    id="create-survey-modal"
    class="custom-modal"
    title="Survey Creator"
    size="lg"
    centered
    @hidden="clearModal"
    no-close-on-backdrop
  >
    <b-form>
      <b-row no-gutters class="mb-2 mt-4">
        <b-col sm="12" md="3">
          <h6 class="primary-label">Survey Details</h6>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-title">
                <div slot="label" class="secondary-label">
                  Survey Title
                  <sup class="text-danger font-weight-bold">*</sup>
                </div>
                <b-input
                  id="input-title"
                  class="col-md-6"
                  type="text"
                  v-model="form.inputTitle"
                  placeholder="Enter Title"
                  required
                  :maxlength="maxInputTitleLength"
                  :state="isInvalid('title')"
                >
                </b-input>
                <b-form-invalid-feedback :state="isInvalid('title')">
                  {{ errorMessage("title") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="input-description">
                <div slot="label" class="secondary-label">
                  Survey Description
                </div>
                <b-form-textarea
                  id="input-description"
                  rows="4"
                  v-model="form.inputDescription"
                  :maxlength="maxInputDescriptionLength"
                  placeholder="Enter Description"
                  :state="isInvalid('description')"
                >
                </b-form-textarea>
                <b-form-invalid-feedback :state="isInvalid('description')">
                  {{ errorMessage("description") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="py-4">
        <hr class="form-divider" />
      </div>
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="primary-label">Publish Survey</h6>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="secondary-label">
              Publish Survey <sup class="text-danger font-weight-bold">*</sup>
            </div>
            <b-form-radio-group
              v-model="isPublishSurvey"
              :options="optionsBool"
            >
            </b-form-radio-group>
            <b-form-input
              type="text"
              hidden
              :state="isInvalid('is_enabled')"
            ></b-form-input>
            <b-form-invalid-feedback :state="isInvalid('is_enabled')">
              {{ errorMessage("is_enabled") }}
            </b-form-invalid-feedback>
          </b-form-group>
          <div v-if="form.inputWillPublishSurvey">
            <div class="secondary-label mb-2 mt-32">
              Duration of Survey
              <sup class="text-danger font-weight-bold">*</sup>
            </div>
            <b-row class="pb-4">
              <b-col lg="6" class="mb-2">
                <div class="tertiary-label mb-2">Start Date</div>
                <b-input-group
                  class="date-picker-wrapper"
                  :class="{ 'invalid-date': errorMessage('invalidTimeSpan') }"
                >
                  <b-input-group-text slot="append">
                    <i class="icon-calendar-empty"></i>
                  </b-input-group-text>
                  <datepicker
                    v-model="form.inputPublishStartDate"
                    :config="startDatePickerConfig"
                  >
                  </datepicker>
                </b-input-group>
              </b-col>
              <b-col lg="6" class="mb-2">
                <div class="tertiary-label mb-2">End Date</div>
                <b-input-group
                  class="date-picker-wrapper"
                  :class="{ 'invalid-date': errorMessage('invalidTimeSpan') }"
                >
                  <b-input-group-text slot="append">
                    <i class="icon-calendar-empty"></i>
                  </b-input-group-text>
                  <datepicker
                    v-model="form.inputPublishEndDate"
                    :config="endDatePickerConfig"
                  >
                  </datepicker>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col span="12" v-if="!form.isTimeApplicable" class="reduce-top-20">
                <b-form-invalid-feedback 
                  :force-show="!!errorMessage('invalidTimeSpan')"
                  class="text-center"
                >
                  {{ errorMessage("invalidTimeSpan") }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <div id="custom-timepicker-survey" style="width:100%">
                  <b-form-group
                    class="secondary-label"
                  >
                    <label class="align-top">Start Time</label>
                    <b-form-input
                      :disabled="
                        !form.isTimeApplicable
                      "
                      type="time"
                      v-model="form.inputPublishStartTime"
                    />
                  </b-form-group>
                </div>
                <b-form-invalid-feedback :state="isInvalid('invalidStartTime')">
                  {{ errorMessage("invalidStartTime") }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col lg="6" class="mb-2" >

                <div id="custom-timepicker-survey">
                  <b-form-group
                    class="secondary-label"
                  >
                    <label class="align-top">End Time</label>
                    <b-form-input
                      :disabled="
                        !form.isTimeApplicable
                      "
                      type="time"

                      v-model="form.inputPublishEndTime"
                    />
                  </b-form-group>
                </div>
                <b-form-invalid-feedback :state="isInvalid('invalidEndTime')">
                  {{ errorMessage("invalidEndTime") }}
                </b-form-invalid-feedback>

              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                  <div class="tertiary">
                    <b-form-checkbox v-model="form.isTimeApplicable">
                      <div class="tertiary-label">Applicable to a certain time only</div>
                    </b-form-checkbox>
                  </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col span="12" v-if="form.isTimeApplicable">
                <b-form-invalid-feedback 
                  :force-show="!!errorMessage('invalidTimeSpan')"
                  class="text-center"
                >
                  {{ errorMessage("invalidTimeSpan") }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <div class="py-4">
        <hr class="form-divider" />
      </div>
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="primary-label">Survey Rules</h6>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="secondary-label">
              Require Users to Register/Login
              <sup class="text-danger font-weight-bold">*</sup>
            </div>
            <div class="tertiary-label mb-3 gray-500">
              (Users are allowed to use mobile no. upon registration)
            </div>
            <b-form-radio-group
              v-model="form.inputWillRequireUserAuth"
              :options="optionsBool"
            >
            </b-form-radio-group>
            <b-form-input
              type="text"
              hidden
              :state="isInvalid('is_login_required')"
            ></b-form-input>
            <b-form-invalid-feedback :state="isInvalid('is_login_required')">
              {{ errorMessage("is_login_required") }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="form.inputWillRequireUserAuth" class="mt-3">
            <div slot="label" v-if="isUcoin" class="secondary-label">Earn UCoin Points</div>
            <div slot="label" v-else class="secondary-label">Incentive Type</div>
            <b-form-radio-group
              v-model="form.inputIncentiveType"
              :options="incentiveTypes"
              @change="removeIncentiveValues"
            >
            </b-form-radio-group>
          </b-form-group>
          <b-row
            v-if="
              form.inputWillRequireUserAuth && form.inputIncentiveType == 'points'
            "
            class="mt-3"
          >
            <b-col md="12">
              <b-form-group label-for="input-points-to-earn">
                <div slot="label" class="secondary-label">Points to earn</div>
                <div class="d-flex position-relative">
                  <b-form-input
                  id="input-points-to-earn"
                  type="number"
                  class="points-input-survey"
                  v-model="form.inputPointsToEarn"
                  placeholder="0"
                  ref="earnPoints"
                  min="0"
                  max="9999"
                  required
                  :state="isInvalid('incentiveType')"
                  :formatter="formatPoints"
                >
                </b-form-input>
                <div class="input-controls position-absolute d-inline-flex flex-column h-100">
                  <b-button class="value-control -up" variant="link"
                    @click="controlValue('inputPointsToEarn', 'up', 'earnPoints')">
                    <img src="@/assets/images/icons/arrow-up-new.svg" alt="Dropdown" />
                    
                    </b-button>
                  <b-button class="value-control -down" variant="link"
                    @click="controlValue('inputPointsToEarn', 'down', 'earnPoints')">
                      <img src="@/assets/images/icons/arrow-up-new.svg" alt="Dropdown" />
                    </b-button>
                </div>
                </div>
                
                <b-form-invalid-feedback :state="isInvalid('incentiveType')">
                  {{ errorMessage("incentiveType") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row 
            v-if="
              form.inputWillRequireUserAuth && form.inputIncentiveType == 'rewards'
            ">
            <b-col md="12">
              <b-form-group id="rewards-list">
                <div slot="label" class="secondary-label">Rewards to issue</div>
                <div id="multiselect-override">
                  <Multiselect
                    v-model="form.inputRewards"
                    placeholder="Select a Reward"
                    label="name"
                    track-by="value"
                    :options="rewardOptions"
                    :multiple="true"
                    :closeOnSelect="true"
                    :show-labels="false"
                    :taggable="true"
                    :limit="3"
                    :limitText="limitText"
                    class="multiselect-survey"
                    :class="{'has-selection': form.inputRewards.length > 0}"
                    :state="isInvalid('incentiveType')"
                  />
                </div>
                <b-form-invalid-feedback :state="isInvalid('incentiveType')">
                  {{ errorMessage("incentiveType") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-radio-group
                v-model="form.isEditable"
                :options="isEditableOptions"
                stacked
              >
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row
            v-if="
              form.inputWillRequireUserAuth && !form.isEditable
            "
            class="mt-2"
          >
            <b-col md="7">
              <b-form-group>
                <div slot="label" class="secondary-label">Number of times a user can respond</div>
                <b-form-select v-model="form.answerLimit" :options="timesOptions"/>
                <b-form-invalid-feedback :state="isInvalid('answer_limit')">
                  {{ errorMessage("answer_limit") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="py-4">
        <hr class="form-divider" />
      </div>
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="primary-label">Success Page</h6>
        </b-col>
        <b-col>
          <b-form-group label-for="input-thank-you-message">
            <div slot="label" class="secondary-label">
              Thank You Message
              <sup class="text-danger font-weight-bold">*</sup>
            </div>
            <b-form-textarea
              id="input-thank-you-message"
              rows="4"
              v-model="form.inputThankYouMessage"
              :maxlength="maxInputThankYouMessageLength"
              :state="isInvalid('success_text')"
            >
            </b-form-textarea>
            <b-form-invalid-feedback :state="isInvalid('success_text')">
              {{ errorMessage("success_text") }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <div slot="label" class="secondary-label">
              Add Button <sup class="text-danger font-weight-bold">*</sup>
            </div>
            <b-form-radio-group
              v-model="form.inputWillAddButton"
              :options="optionsBool"
            >
            </b-form-radio-group>
          </b-form-group>
          <div v-if="form.inputWillAddButton">
            <b-form-group label-for="input-button-name" class="mb-4">
              <div slot="label" class="secondary-label">Button Name</div>
              <b-input
                id="input-button-name"
                type="text"
                v-model="form.inputButtonName"
                placeholder="Type Here"
                required
                :maxlength="maxInputButtonNameLength"
                :state="isInvalid('button_name')"
                @keypress.native="filterAlphaNumeric"
              >
              </b-input>
              <b-form-invalid-feedback :state="isInvalid('button_name')">
                {{ errorMessage("button_name") }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-for="input-button-link">
              <div slot="label" class="secondary-label">Button Link</div>
              <b-input
                id="input-button-link"
                type="text"
                v-model="form.inputButtonLink"
                placeholder="https://"
                required
                :maxlength="maxInputButtonLinkLength"
                :state="isInvalid('button_link')"
              >
              </b-input>
              <b-form-invalid-feedback :state="isInvalid('button_link')">
                {{ errorMessage("button_link") }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <div slot="modal-footer" class="w-100">
        <b-row align-h="end" no-gutters>
          <b-col xs="12" md="4" class="px-2 mb-md-0">
            <b-btn
              variant="ghost"
              class="btn-block btn-cancel"
              @click="$root.$emit('bv::hide::modal', 'create-survey-modal')"
              :disabled="isLoading"
            >
              Cancel
            </b-btn>
          </b-col>
          <b-col xs="12" md="4" class="px-2 text-md-right">
            <b-btn
              variant="primary"
              class="btn-block"
              @click="preValidateForm"
              :disabled="isLoading"
            >
              Continue
            </b-btn>
          </b-col>
        </b-row>
    </div>
  </b-modal>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";

import { mapActions, mapGetters, mapMutations } from "vuex";

const dateToday = moment().format("YYYY-MM-DD");
const dateTomorrow = moment()
    .add(1, "d")
    .format("YYYY-MM-DD");

export default {
    name: "CreateSurveyModal",
    props: ["isUcoin"],
    data() {
        return {
            isEditableOptions: [
                { text: "Allow users to edit response", value: 1 },
                {
                    text: "Limit number of times a user can answer",
                    value: 0
                }
            ],
            maxInputTitleLength: 50,
            maxInputDescriptionLength: 1000,
            maxInputThankYouMessageLength: 300,
            maxInputButtonNameLength: 30,
            maxInputButtonLinkLength: 100,
            optionsBool: [
                { text: "Yes", value: true },
                { text: "No", value: false }
            ],
            incentiveTypes: [
                { text: "Points", value: "points" },
                { text: "Rewards", value: "rewards" },
                { text: "None", value: "none" }
            ],
            isPublishSurvey: true,
            rewardOptions: [],
            startDatePickerConfig: {
                altInput: true,
                altFormat: "j M, Y",
                dateFormat: "Y-m-d",
                defaultDate: [dateToday],
                minDate: dateToday
            },
            endDatePickerConfig: {
                altInput: true,
                altFormat: "j M, Y",
                dateFormat: "Y-m-d",
                defaultDate: [dateTomorrow],
                minDate: dateTomorrow
            },
            form: this.initForm(),
            isInvalidDate: false,
            timesOptions: [
                { text: "1 Time", value: "1" },
                { text: "2 Times", value: "2" },
                { text: "3 Times", value: "3" },
                { text: "4 Times", value: "4" },
                { text: "5 Times", value: "5" }
            ]
        };
    },
    async created() {
        await this.getRewardsList();
        this.rewardOptions = this.rewardsList;
    },
    computed: {
        ...mapGetters("surveys", [
            "isLoading",
            "errors",
            "survey",
            "rewardsList"
        ])
    },
    // watch: {
      
    // },
    methods: {
        ...mapActions("surveys", ["createSurvey", "getRewardsList"]),
        ...mapMutations("surveys", ["setErrors"]),
        initPublishSurveyValues() {
          this.form.inputPublishStartDate = moment().format("YYYY-MM-DD")
          this.form.inputPublishEndDate = moment()
              .add(1, "d")
              .format("YYYY-MM-DD")
          this.form.inputPublishStartTime = ""
          this.form.inputPublishEndTime = ""
          this.form.isTimeApplicable =  false

          if (this.errors && this.errors.hasOwnProperty("invalidStartTime")) this.errors["invalidStartTime"] = null
          if (this.errors && this.errors.hasOwnProperty("invalidEndTime")) this.errors["invalidEndTime"] = null
          if (this.errors && this.errors.hasOwnProperty("invalidTimeSpan")) this.errors["invalidTimeSpan"] = null
        },
        initForm() {
            return {
                inputTitle: "",
                inputDescription: "",
                inputWillPublishSurvey: true,
                inputPublishStartDate: moment().format("YYYY-MM-DD"),
                inputPublishEndDate: moment()
                    .add(1, "d")
                    .format("YYYY-MM-DD"),
                inputPublishStartTime: "",
                inputPublishEndTime: "",
                inputWillRequireUserAuth: true,
                inputIncentiveType: "points",
                inputRewards: [],
                inputPointsToEarn: null,
                inputThankYouMessage:
                    "Thank you for submitting your response!\n\nYour answer has been successfully saved.",
                inputWillAddButton: true,
                inputButtonName: "",
                inputButtonLink: "",
                answerLimit: 1,
                isEditable: 1,
                isTimeApplicable: false
            };
        },
        isNotAlphaNumericPunctuations(input) {
            return /[^A-Za-z0-9 ,.!?'":()\s\-]+/g.test(input);
        },
        filterAlphaNumericPunctuations(e) {
            if (
                this.isNotAlphaNumericPunctuations(
                    String.fromCharCode(e.keyCode)
                )
            )
                e.preventDefault();
        },
        isNotAlphaNumeric(input) {
            return /[^A-Za-z0-9\s]+/g.test(input);
        },
        filterAlphaNumeric(e) {
            if (this.isNotAlphaNumeric(String.fromCharCode(e.keyCode)))
                e.preventDefault();
        },
        formatPoints(points) {
            if (points !== null && points !== "") {
                return points.substring(0, 5);
            } else {
                return points;
            }
        },
        clearModal() {
            this.setErrors(null);
            this.form = this.initForm();
        },
        preValidateForm() {
            const errorsCollection = {};
            const form = this.form;

            if (form.inputTitle === "") {
                errorsCollection["title"] = "Title is required";
            }

            // if (
            //     form.inputTitle &&
            //     this.isNotAlphaNumericPunctuations(form.inputTitle)
            // ) {
            //     errorsCollection["title"] =
            //         "Only alpha numeric with punctuation characters are allowed";
            // }

            // if (
            //     form.inputDescription &&
            //     this.isNotAlphaNumericPunctuations(form.inputDescription)
            // ) {
            //     errorsCollection["description"] =
            //         "Only alpha numeric with punctuation characters are allowed";
            // }

            if (form.isTimeApplicable) {
              if (form.inputPublishStartTime == "") {
                errorsCollection["invalidStartTime"] = "Set a valid start time";
              }

              if (form.inputPublishEndTime == "") {
                errorsCollection["invalidEndTime"] = "Set a valid end time";
              }
              
              if (!errorsCollection.hasOwnProperty("invalidEndTime") && !errorsCollection.hasOwnProperty("invalidStartTime")) {
                const startDateTime = this.combineDateTime(form.inputPublishStartDate, form.inputPublishStartTime);
                const endDateTime = this.combineDateTime(form.inputPublishEndDate, form.inputPublishEndTime);
                const currentDate = new Date();

                if (startDateTime < currentDate) {
                  errorsCollection["invalidTimeSpan"] = "Start date and time should not be earlier than the current date and time";
                }

                if (
                  form.inputWillPublishSurvey &&
                  endDateTime <= startDateTime
                ) {
                  errorsCollection["invalidTimeSpan"] = "End date and time must be later than the start date and time.";
                }
              }

            }
            else {
              if (
                  form.inputWillPublishSurvey &&
                  form.inputPublishStartDate >= form.inputPublishEndDate
              ) {
                  errorsCollection["invalidTimeSpan"] = "Invalid Start and End Date";
              } 
            }

            if (
                form.inputWillRequireUserAuth &&
                form.inputIncentiveType === "points" &&
                (form.inputPointsToEarn === null ||
                    form.inputPointsToEarn === "")
            ) {
                errorsCollection["incentiveType"] = "Set number of points to issue";
            } else if (
                form.inputWillRequireUserAuth &&
                form.inputIncentiveType === "points" &&
                form.inputPointsToEarn < 1
            ) {
                errorsCollection["incentiveType"] = "Points must be greater than 0";
            } else if (
                form.inputWillRequireUserAuth &&
                form.inputIncentiveType === "points" &&
                form.inputPointsToEarn > 9999
            ) {
                errorsCollection["incentiveType"] = "Points must not exceed 9,999";
            } else if (
                form.inputWillRequireUserAuth &&
                form.inputIncentiveType === "rewards" &&
                form.inputRewards.length < 1
            ) {
                errorsCollection["incentiveType"] = "Select at least 1 reward";
            }

            if (form.inputThankYouMessage === "") {
                errorsCollection["success_text"] = "Success text is required";
            }

            // if (
            //     form.inputThankYouMessage &&
            //     this.isNotAlphaNumericPunctuations(form.inputThankYouMessage)
            // ) {
            //     errorsCollection["success_text"] =
            //         "Only alpha numeric with punctuation characters are allowed";
            // }

            if (form.inputWillAddButton) {
                if (form.inputButtonName === "") {
                    errorsCollection["button_name"] = "Button name is required";
                }

                if (
                    form.inputButtonName &&
                    this.isNotAlphaNumeric(form.inputButtonName)
                ) {
                    errorsCollection["button_name"] =
                        "Only alpha numeric characters are allowed";
                }

                if (form.inputButtonLink === "") {
                    errorsCollection["button_link"] = "Button link is required";
                }
            }

            this.setErrors(errorsCollection);

            if (Object.keys(errorsCollection).length <= 0) {
                this.onCreate();
            }
        },
        combineDateTime(dateStr, timeStr) {
            const timeArray = timeStr.split(":");
            const hours = parseInt(timeArray[0], 10);
            const minutes = parseInt(timeArray[1], 10);
            const date = new Date(dateStr);
            date.setHours(hours, minutes, 0, 0);
            return date;
        },
        initTimeValue() {
            return "";
        },
        removeIncentiveValues() {
            if (this.form.incentiveType == "points") {
                this.form.inputRewards = [];
            } else if (this.form.incentiveType == "rewards") {
                this.form.inputPointsToEarn = 0;
            } else {
                this.form.inputRewards = [];
                this.form.inputPointsToEarn = 0;
            }
            if (
                this.errors &&
                Object.keys(this.errors).includes("incentiveType")
            ) {
                delete this.errors["incentiveType"];
            }
        },
        limitText(count) {
            return `and ${count} other reward${count > 1 ? "s" : ""}`;
        },
        onCreate() {
            const form = this.form;

            const payload = {
                title: form.inputTitle,
                description: form.inputDescription,
                is_enabled: form.inputWillPublishSurvey,
                is_login_required: form.inputWillRequireUserAuth,
                success_text: form.inputThankYouMessage,
                button_name: form.inputButtonName,
                button_link: form.inputButtonLink,
                answer_limit: form.isEditable == 1 ? 0 : form.answerLimit,
                is_editable: form.isEditable,
                incentive_type: form.inputIncentiveType,
                start_time: "",
                end_time: "",
                rewards: []
            };

            // form.answerLimit == 1 ? 1 : 0

            // console.log(payload);

            if (form.inputWillPublishSurvey) {
                payload["start_date"] = form.inputPublishStartDate;
                payload["end_date"] = form.inputPublishEndDate;

                payload["is_time_applicable"] = form.isTimeApplicable;
                if (form.isTimeApplicable) {
                    payload["start_time"] = form.inputPublishStartTime;
                    payload["end_time"] = form.inputPublishEndTime;
                }
            }
            if (
                !form.inputWillRequireUserAuth ||
                !form.inputIncentiveType == "points"
            ) {
                payload["points"] = 0;
            } else if (
                form.inputIncentiveType == "points" &&
                form.inputPointsToEarn !== null
            ) {
                payload["points"] = form.inputPointsToEarn;
            }

            if (
                form.inputIncentiveType == "rewards" &&
                form.inputRewards.length > 0
            ) {
                const formattedRewards = form.inputRewards.map(reward => ({
                    name: reward.name,
                    uuid: reward.value,
                    description: reward.description
                }));
                payload["rewards"] = formattedRewards;
                const uuidRewards = form.inputRewards.map(reward => reward.value);
                payload["rewards"] = uuidRewards
            }

            if (
                !form.inputWillRequireUserAuth ||
                !form.inputIncentiveType == "points"
            ) {
                payload["points"] = 0;
            }

            if (!form.inputWillAddButton) {
                payload.button_name = "";
                payload.button_link = "";
            }

            this.$nextTick(async () => {
                await this.createSurvey(payload).then(() => {
                    if (
                        this.errors === null ||
                        Object.keys(this.errors).length === 0
                    ) {
                        this.$router.push({
                            name: "surveyQuestion",
                            params: { uuid: this.survey.uuid }
                        });
                    }
                });
            });
        },
        isInvalid(field) {
            if (this.errors === null) {
                return null;
            } else {
                return !Object.keys(this.errors).includes(field)
                    ? null
                    : !Object.keys(this.errors).includes(field);
            }
        },
        errorMessage(field) {
            if (this.errors === null) {
                return "";
            } else if (Object.keys(this.errors).includes(field)) {
                return Array.isArray(this.errors[field])
                    ? this.errors[field].join(" ")
                    : this.errors[field];
            }
        },
        controlValue(field, direction, refI) {
          const { min, max } = this.$refs[refI];
          let valNum = Number(this.form[field]);

          if (direction === "up" && valNum < max) {
            this.form[field]++;
          } else if (direction === "down" && valNum > min) {
            this.form[field]--;
          }
        },
    },
    watch: {
        "form.isTimeApplicable"(checked) {
            if (!checked) {
                this.form.inputPublishStartTime = "";
                this.form.inputPublishEndTime = "";
            }
        },
        isPublishSurvey(newValue, oldValue) {
        this.form.inputWillPublishSurvey = newValue
        if(newValue != oldValue){
            this.initPublishSurveyValues()
        }
      }
    },
    components: {
        Datepicker,
        Multiselect
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
.reduce-top-20 {
  top: -25px;
}

.points-input-survey {
  min-height:44px
}

.gray-500 {
  color: #87929D
}

.multiselect-survey {
    width: 100%;
    min-height: 44px;
}
#multiselect-override {
    .multiselect__tag {
        background: #f3f5f9 !important;
        span {
            color: #2a2a2a;
        }

        .multiselect__tag-icon:after {
            color: #2a2a2a;
        }

        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
            background: #f3f5f9;
        }

        /* Hover color for unselected options */
        .multiselect__option {
            background-color: blue !important; /* Green */
            color: white !important;
        }

        /* Hover color for selected options */
        .multiselect__option--selected:hover {
            background-color: #dc3545 !important; /* Red */
            color: white !important;
        }
    }
    .multiselect__tags {
        border-radius: 8px;
        border: 1px solid #ced4da;
    }
    .multiselect__option--highlight {
        background: #f3f5f9 !important;
        outline: none;
        color: #2a2a2a !important;
    }

    .multiselect__option--highlight:after {
        content: attr(data-select);
        background: #f3f5f9 !important;
        color: #2a2a2a !important;
    }
    .multiselect__placeholder {
      color: #D8DCDE !important;
    }
    .multiselect-survey .multiselect__input, 
    .multiselect-survey .multiselect__single {
      display: block; /* Default to visible */
    }
    .multiselect-survey.has-selection .multiselect__input, 
    .multiselect-survey.has-selection .multiselect__single {
      display: none;
    }
    .multiselect__input::placeholder {
      color: #D8DCDE !important;
  }
}
.mt-32 {
    margin-top: 32px;
}
.custom-control-label {
    padding-left: 6px !important;
}
.input-controls {
  right: 20px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center; 

  &>.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    width: 10px;
    height: 10px;
    background: transparent !important;
    border: 0;
    box-shadow: none !important;
    margin: 1px 0;

    &:active,
    &:focus:active {
      background: transparent !important;
      box-shadow: none !important;
    }

    &.-down {
      transform: rotate(180deg);
    }
  }
  .btn-link {
    box-shadow: none !important
  }
}
</style>
